module.exports = __webpack_public_path__ + "img/city9.7ac52af3.png";